import { useCallback, useMemo, useState } from 'react';
import { IDragHistoryItem } from '~/Hooks';

export const useFitoListDnD = <T extends object>({
  onRearrange,
  unstructuredList,
  enableForceRefresh,
  setIsWaitingForRearrangeToEnd,
}: {
  onRearrange?: (historyItem: IDragHistoryItem[], extraData?: any) => void;
  unstructuredList: T[];
  enableForceRefresh: () => void;
  setIsWaitingForRearrangeToEnd: (isWaiting: boolean) => void;
}) => {
  const [isBeingRearranged, setIsBeingRearranged] = useState(false);

  // onRearrange functions
  const DnDHistory: IDragHistoryItem[] = useMemo(() => [], []);
  const addToDnDHistory = useCallback(
    (historyItem: IDragHistoryItem) => {
      DnDHistory.push(historyItem);
    },
    [DnDHistory],
  );

  const onRearrangeStart = useCallback(async () => {
    setIsWaitingForRearrangeToEnd(true);
    await onRearrange?.(DnDHistory, unstructuredList);
    enableForceRefresh();
  }, [DnDHistory, unstructuredList, onRearrange]);

  return {
    isBeingRearranged,
    setIsBeingRearranged,
    addToDnDHistory,
    onRearrangeStart,
  };
};
